import { ElementType, Template } from "@/types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const FortigoldLabelPopup: Template = {
  id: "fortigold-label-popup",
  name: "Fortigold Label",
  industry: "restaurant",
  elements: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px 20px",
        textAlign: "center",
        maxWidth: "992px",
        width: "auto",
        height: "auto",
        borderRadius: "0px",
        border: "none",
        backgroundColor: "transparent",
      },
      children: [
        {
          id: generateId(),
          type: "image",
          src: "/public/fortigold/label.webp",
          alt: "Fortigold Label",
          styles: {
            width: "100%",
            height: "auto",
            objectFit: "contain",
            margin: "0px 0px 0px 0px",
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            position: "absolute",
            top: "0",
            right: "0",
            width: "40px",
            height: "40px",
            minWidth: "40px",
            minHeight: "40px",
            borderRadius: "100%",
            backgroundColor: "#ffffffa0",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          },
          children: [
            {
              id: generateId(),
              type: "button" as ElementType,
              content: "X",
              styles: {
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                color: "#000000",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
            },
          ],
        },
      ],
    },
  ],
};
